import { useMemo } from "react";
import { Field } from "../../../NotificationsDialog/interfaces/TableRowView";

const useFindCommonIds = (names: string[], fields: Field[]) => {
  const commonIds = useMemo(() => {
    const ids: number[] = [];
    names.forEach((name) => {
      const match = fields.find((field) => field.name === name);
      if (match) {
        ids.push(match.id);
      }
    });
    return ids;
  }, [names, fields]);

  return commonIds;
};

export default useFindCommonIds;
